import { ClipboardCheck } from "lucide-react";

export const TAKING_FILTERS = [
	{
		key: "user_id",
		label: "Usuario",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar usuario",
		options: [],
	},
	{
		key: "status",
		label: "Estado",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar estado",
		options: [
			{ value: "open", label: "Abierta" },
			{ value: "closed", label: "Cerrada" },
		],
	},
	{
		key: "season_id",
		label: "Temporada",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar temporada",
		options: [],
	},
	{ key: "date_from", label: "Fecha Desde", type: "date", value: "", visible: true, placeholder: "Fecha desde" },
	{ key: "date_to", label: "Fecha Hasta", type: "date", value: "", visible: true, placeholder: "Fecha hasta" },
];

export const TAKING_METADATA = {
	title: "Toma de Inventario",
	subtitle: "Visualiza las sesiones de toma de inventario realizadas desde la balanza",
	breadcrumb: "Toma de Inventario",
	icon: ClipboardCheck,
	path: "/inventory-taking",
};

export const TAKING_BASE_TABLE = {
	page: 1,
	per_page: 20,
	order_by: "started_at",
	order_dir: "desc",
};
